export function generateEventColors(event) {
  return {
    main_color: event.main_color,
    accent_color: event.main_color,
  };
}
